import { useState } from "react";
import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import { mdiApps, mdiCashMultiple, mdiDoorOpen, mdiGiftOutline } from "@mdi/js";
import Icon from "@mdi/react";

import ContrastIcon from "components/ContrastIcon";

export interface EventAppsMenuProps {
  onMenuItemSelect: (route: string) => void;
  visibleApps?: string[];
}

export default function EventAppsMenu(props: EventAppsMenuProps) {
  const { onMenuItemSelect, visibleApps } = props;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  function handleClick(event: React.MouseEvent<HTMLButtonElement>) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  function handleSecretSanta() {
    handleClose();
    onMenuItemSelect("apps/secret-santa");
  }

  function handleMoneyManager() {
    handleClose();
    onMenuItemSelect("apps/money-manager");
  }

  function handleRoomManager() {
    handleClose();
    onMenuItemSelect("apps/room-manager");
  }

  return (
    <div>
      <IconButton
        id='event-apps-button'
        aria-controls={open ? "event-apps-menu" : undefined}
        aria-haspopup='true'
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        size='large'
      >
        <ContrastIcon path={mdiApps} size={1} title='Apps' />
      </IconButton>

      <Menu
        id='event-apps-menu'
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "event-apps-button",
        }}
      >
        {(!visibleApps || visibleApps.includes("money-manager")) && (
          <MenuItem onClick={handleMoneyManager}>
            <ListItemIcon>
              <Icon path={mdiCashMultiple} size={0.8} />
            </ListItemIcon>
            <ListItemText>Money Manager</ListItemText>
          </MenuItem>
        )}
        {(!visibleApps || visibleApps.includes("room-manager")) && (
          <MenuItem onClick={handleRoomManager}>
            <ListItemIcon>
              <Icon path={mdiDoorOpen} size={0.8} />
            </ListItemIcon>
            <ListItemText>Rooms Manager</ListItemText>
          </MenuItem>
        )}
        {(!visibleApps || visibleApps.includes("secret-santa")) && (
          <MenuItem onClick={handleSecretSanta}>
            <ListItemIcon>
              <Icon path={mdiGiftOutline} size={0.8} />
            </ListItemIcon>
            <ListItemText>Secret Santa</ListItemText>
          </MenuItem>
        )}
      </Menu>
    </div>
  );
}
